export default __webpack_public_path__ + "static/media/publish_modules_prac.df83f890.svg";